<template>
    <div class="detail" @click="close">
        <div class="select">
            <div class="option" :class="{optionblue:showOne}" @click.stop="select(1);">
                <div class="p">船公司</div>
                <img v-if="showOne" src="@/assets/img/downblue.png" alt="">
                <img v-else src="@/assets/img/down.png" alt="">
            </div>
            <div class="option" :class="{optionblue:showTwo}" @click.stop="select(2)">
                <div class="p">有效期</div>
                <img v-if="showTwo" src="@/assets/img/downblue.png" alt="">
                <img v-else src="@/assets/img/down.png" alt="">
            </div>

        </div>
        <div class="ship" v-show="showOne" @click.stop="showOne=true">
            <div class="box" style="width:90%;overflow:hidden;">
                <div class="weui-cell" style="padding:16px 0;margin:0 auto;width:100%;border-bottom:1px solid #eeeeee;">
                    <input class="weui-input" type="text" v-model="shippingCompany" placeholder="请输入船公司">
                </div>
            </div>
            <div class="box" style="width:90%;overflow:hidden;">
                <div class="weui-cell">
                    <div class="weui-cell__hd" style="width:50%!important;">
                        <button style="width:60%;" class="weui-btn weui-btn_disabled weui-btn_primary" size="mini" @click.stop="clearShip"
                            v-prevent-re-click>重置</button>
                    </div>
                    <div class="weui-cell__bd" style="width:50%!important;">
                        <button style="width:60%;" class="weui-btn weui-btn_primary" size="mini" @click.stop="submitShip(shippingCompany)"
                            v-prevent-re-click>确定</button>
                    </div>
                </div>
            </div>
            <!-- <div class="weui-cell" @click="code = 0" style="padding:16px 0;width:90%; margin:0 auto;">
                <div class="weui-cell__hd"><label for="time-format" class="weui-label">中远</label></div>
            </div>
            <div class="weui-cell" @click="code = 0">
                <div class="weui-cell__hd"><label for="time-format" class="weui-label">马士基</label></div>
            </div> -->
        </div>
        <div class="timeselect" v-show="showTwo" @click.stop="showTwo=true">
            <div class="box">
                <div class="weui-cell">
                    <div class="weui-cell__hd"><label for="time-format" class="weui-label">开始日期</label></div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" readonly="true" type="text" v-model="validityStartDate" @focus="startDate" placeholder="请选择开始日期">
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd"><label for="time-format" class="weui-label">结束日期</label></div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" readonly="true" type="text" v-model="validityEndDate" @focus="endDate" placeholder="请选择结束日期">
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd" style="width:50%!important;">
                        <button style="width:60%;" class="weui-btn weui-btn_disabled weui-btn_primary" size="mini" @click.stop="clear"
                            v-prevent-re-click>重置</button>
                    </div>
                    <div class="weui-cell__bd" style="width:50%!important;">
                        <button style="width:60%;" class="weui-btn weui-btn_primary" size="mini"
                            @click.stop="submit(validityStartDate,validityEndDate)" v-prevent-re-click>确定</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="fav">
            <div class="box betweeen">
                <div class="box-l">
                    <img src="@/assets/img/plus.png" alt="">
                    <div class="p">订阅后可实时接收该航线的最新信息</div>
                </div>
                <div class="box-r">
                    <button v-if='data === 0' class="love" @click="favor" v-prevent-re-click>立即订阅</button>
                    <button v-else class="can" @click="cancleFavor" v-prevent-re-click>取消订阅</button>
                </div>
            </div>
        </div>

        <div class="list">
            <div class="item box" v-for="item in dataList" :key="item.id">
                <div class="box-t">
                    <div class="box-l">
                        <img class="circle" src="@/assets/img/circle.png" alt="">
                        <div class="p">{{item.loadingPart}}</div>
                        <div class="line"></div>
                        <img class="port" src="@/assets/img/port.png" alt="">
                        <div class="p">{{item.destinationPart}}</div>
                    </div>
                    <div class="box-r">
                        <div class="p">{{item.shippingCompany}}</div>
                    </div>
                </div>
                <div class="zq">
                    <div class="p">班期 {{item.schedule?item.schedule:'-'}}</div>
                    <div class="line"></div>
                    <div class="p">航程 {{item.voyage?item.voyage:'-'}}</div>
                </div>
                <div class="price">
                    <div class="li">
                        <div class="gp">20GP</div>
                        <div class="red">{{item.price20gp?'$'+item.price20gp:'-'}}</div>
                    </div>
                    <div class="li">
                        <div class="gp">40GP</div>
                        <div class="red">{{item.price40gp?'$'+item.price40gp:'-'}}</div>
                    </div>
                    <div class="li">
                        <div class="gp">40HP</div>
                        <div class="red">{{item.price40hq?'$'+item.price40hq:'-'}}</div>
                    </div>
                </div>
                <div class="time">
                    <img src="@/assets/img/time.png" alt="">
                    <div class="p">{{item.validityStartDate}}~{{item.validityEndDate}}有效</div>
                </div>
            </div>
        </div>
        <div class="noadta" v-show="noData">
            <div class="pic">
                <img src="@/assets/img/noship.png" alt="">
            </div>
            <div class="p1">暂无航线</div>
            <div class="p2">可点击订阅，有航线时会第一时间<br />发送微信通知您</div>
        </div>
        <div class="weui-loadmore" v-show="loading">
            <i class="weui-loading"></i>
            <span class="weui-loadmore__tips">正在加载</span>
        </div>
        <div class="weui-loadmore weui-loadmore_line" v-show="isLast">
            <span class="weui-loadmore__tips">已加载全部</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "Detail",
    components: {

    },
    data() {
        return {
            loadingPart: '',
            destinationPart: '',
            loading: false,
            dataList: [],
            data: 0,
            code: 0,
            validityStartDate: '',
            validityEndDate: '',
            shippingCompany: '',
            noData: false,
            scrollpos: 0,
            isLast: false,
            page: 1,
            showOne: false,
            showTwo: false
        };
    },
    created() {
        this.loadingPart = this.$route.query.loadingPart;
        this.destinationPart = this.$route.query.destinationPart;
        this.getCollectStatus()
        this.getList()
        window.addEventListener("scroll", this.handleScroll, true); //监听函数        
        // window.addEventListener("click", this.close, true); //监听函数
    },
    mounted() {

    },
    methods: {
        //获取数据
        getList() {
            this.loading = true;
            this.$http.post("/wx/freightRateList", {
                destinationPart: this.destinationPart,
                limit: 10,
                loadingPart: this.loadingPart,
                order: "",
                page: this.page,
                sidx: "",
                shippingCompany: this.shippingCompany,
                startTime: this.validityStartDate,
                endTime: this.validityEndDate
            }).then(res => {
                this.loading = false;
                if (res.data.code == 0) {
                    this.dataList.push(...res.data.data.list);
                    if (res.data.data.list.length < 10) {
                        this.isLast = true;
                    }
                    if (this.dataList.length == 0) {
                        this.noData = true;
                        this.isLast = false;
                    }
                }
            });
        },
        // 收藏状态
        getCollectStatus() {
            let json = {
                destinationPart: this.destinationPart,
                limit: 10,
                loadingPart: this.loadingPart,
                order: "",
                page: 1,
                sidx: "",
            }
            this.$http.post("/wx/collectStatus", json).then(res => {
                this.data = res.data.data
            });
        },
        // 订阅
        favor() {
            let json = {
                destinationPart: this.destinationPart,
                limit: 10,
                loadingPart: this.loadingPart,
                order: "",
                page: 1,
                sidx: "",
            }
            this.$http.post("/wx/collectFreightRate", json).then(res => {
                if (res.status == 200) {
                    this.getCollectStatus()
                    this.$weui.toast("订阅成功");
                }
            });
        },
        // 取消订阅
        cancleFavor() {
            this.$weui.dialog({
                title: '提示',
                content: '是否取消订阅该航线，取消后将无法收到该航线新动态',
                buttons: [{
                    label: '取消',
                    type: 'default',
                    onClick: () => {

                    }
                }, {
                    label: '确定',
                    type: 'primary',
                    onClick: () => {
                        this.$weui.toast("操作成功");
                        let json = {
                            destinationPart: this.destinationPart,
                            limit: 10,
                            loadingPart: this.loadingPart,
                            order: "",
                            page: 1,
                            sidx: ""
                        }
                        this.$http.post("/wx/collectDelete", json).then(res => {
                            if (res.status == 200) {
                                this.getCollectStatus()
                            }
                        });
                    }
                }]
            })
        },

        select(state) {
            if (state == 1) {
                this.showOne = !this.showOne
                this.showTwo = false
            }
            if (state == 2) {
                this.showTwo = !this.showTwo
                this.showOne = false
            }
        },
        // 开始日期选择器
        startDate() {
            this.$weui.datePicker({
                start: new Date().getFullYear(),
                end: new Date().getFullYear() + 10,
                defaultValue: [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()],
                onConfirm: (result) => {
                    let year = result[0].value;
                    let month = result[1].value < 10 ? '0' + result[1].value : result[1].value
                    let dat = result[2].value < 10 ? '0' + result[2].value : result[2].value
                    this.validityStartDate = year + '-' + month + '-' + dat
                },
                title: '开始日期'
            });
        },
        // 结束日期选择器
        endDate() {
            this.$weui.datePicker({
                start: new Date().getFullYear(),
                end: new Date().getFullYear() + 10,
                defaultValue: [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()],
                onConfirm: (result) => {
                    let year = result[0].value;
                    let month = result[1].value < 10 ? '0' + result[1].value : result[1].value
                    let dat = result[2].value < 10 ? '0' + result[2].value : result[2].value
                    this.validityEndDate = year + '-' + month + '-' + dat
                },
                title: '结束日期'
            });
        },
        // 日期重置
        clear() {
            this.validityStartDate = '';
            this.validityEndDate = '';
            this.page = 1;
            this.dataList = [];
            this.getList()
            this.noData = false
            this.showTwo = false;
        },
        // 船公司重置
        clearShip() {
            this.shippingCompany = ''
            this.page = 1;
            this.dataList = [];
            this.getList()
            this.noData = false
            this.showOne = false;
        },
        // 有限期确定
        submit(val, value) {
            this.validityStartDate = val
            this.validityEndDate = value
            if (val === '' || value === '') {
                this.$weui.topTips("请选择有效期");
            } else {
                this.page = 1;
                this.dataList = [];
                this.getList()
                this.loading = true
                this.showTwo = false;
                this.noData = false
            }
        },
        // 船公司确定
        submitShip(val) {
            this.shippingCompany = val
            if (this.shippingCompany === '') {
                this.$weui.topTips("请输入船公司");
            } else {
                this.page = 1;
                this.dataList = [];
                this.getList()
                this.loading = true
                this.showOne = false;
                this.noData = false
            }
        },
        // 滚动加载
        handleScroll() {
            let scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop; //变量scrollTop是滚动条滚动时，距离顶部的距离
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight; //变量windowHeight是可视区的高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight; //变量scrollHeight是滚动条的总高度
            this.scrollpos = scrollTop;
            var sum = Math.abs(Math.floor(scrollTop + windowHeight) - scrollHeight);
            if (!this.isLast && sum <= 1 && !this.loading) {
                this.page++;
                this.getList();
            }
        },
        close() {
            this.showOne = false
            this.showTwo = false
        }
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll, true);
    },
}
</script>

<style lang='less' scoped>
.detail {
    width: 100vw;
    height: 100%;
    min-height: 100vh;
    padding-bottom: 20px;
    background: #f5f5f5;
    .select {
        width: 100%;
        background: #ffffff;
        border-bottom: 1px solid #eeeeee;
        height: 90px;
        display: flex;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        .option {
            width: 50%;
            height: 90px;
            display: flex;
            justify-content: center;
            align-items: center;
            .p {
                font-size: 28px;
                color: #333333;
                padding-right: 14px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            img {
                width: 24px;
            }
        }
        .optionblue {
            .p {
                color: #2865ff;
            }
        }
    }
    .ship {
        width: 100%;
        max-height: 50vh;
        overflow-y: auto;
        background: #ffffff;
        position: fixed;
        top: 90px;
        left: 0;
        border-bottom: 1px solid #eeeeee;
        .shipcompany {
            font-size: 28px;
            color: #333333;
            width: 90%;
            height: 90px;
            line-height: 90px;
            padding: 0 5%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .shipcompany:hover {
            color: #2865ff;
        }
    }
    .timeselect {
        width: 100%;
        background: #ffffff;
        position: fixed;
        top: 90px;
        left: 0;
        border-bottom: 1px solid #eeeeee;
        .box {
            .p {
                padding-left: 5%;
                padding: 20px 0 10px;
                font-size: 28px;
                color: #333333;
            }
            .weui-cell {
                .weui-cell__bd {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
    .fav {
        margin-top: 90px;
        width: 100vw;
        height: 90px;
        background: #ffede4;
        .box {
            height: 90px;
            align-items: center;
            .box-l {
                display: flex;
                height: 90px;
                align-items: center;
                img {
                    height: 29px;
                }
                .p {
                    font-size: 26px;
                    color: #ff5b28;
                    padding-left: 13px;
                    white-space: nowrap;
                }
            }
            .box-r {
                height: 90px;
                display: flex;
                align-items: center;
                .love {
                    width: 128px;
                    height: 46px;
                    background: #ff8e6a;
                    border-radius: 4px;
                    font-size: 22px;
                    color: #ffffff;
                }
                .can {
                    width: 128px;
                    height: 46px;
                    border: 2px solid #ff8e6a;
                    border-radius: 4px;
                    font-size: 22px;
                    color: #ff8e6a;
                }
            }
        }
    }
    .list {
        .item {
            padding: 30px;
            background: #ffffff;
            border-radius: 6px;
            margin-top: 20px;
            overflow: hidden;
            .box-t {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .box-l {
                    width: 68%;
                    display: flex;
                    align-items: center;
                    .circle {
                        width: 20px;
                    }
                    .p {
                        padding-left: 10px;
                        font-size: 28px;
                        color: #333333;
                        width: 600px;
                        word-break: break-word;
                    }
                    .line {
                        width: 60px;
                        height: 0px;
                        border-bottom: 2px dashed #2ebe8c;
                        margin: 0 20px;
                    }
                    .port {
                        width: 20px;
                    }
                }
                .box-r {
                    width: 30%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    .p {
                        padding: 6px 30px;
                        background: #e2ecff;
                        border-radius: 4px;
                        font-size: 24px;
                        color: #2865ff;
                        text-align: center;
                        white-space: nowrap;
                    }
                }
            }
            .zq {
                margin: 26px 0;
                display: flex;
                align-items: center;
                .p {
                    font-size: 24px;
                    color: #333333;
                }
                .line {
                    width: 2px;
                    height: 28px;
                    background: #cccccc;
                    margin: 0 30px;
                }
            }
            .price {
                display: flex;
                .li {
                    margin-right: 140px;
                    .gp {
                        font-size: 24px;
                        color: #666666;
                    }
                    .red {
                        font-size: 28px;
                        color: #ff5e5e;
                        padding: 0 0 30px;
                    }
                }
            }
            .time {
                display: flex;
                align-items: center;
                img {
                    width: 22px;
                }
                .p {
                    font-size: 24px;
                    color: #999999;
                    padding-left: 11px;
                }
            }
        }
    }
    .noadta {
        width: 100%;
        .pic {
            width: 270px;
            margin: 178px auto 68px;
            img {
                width: 100%;
            }
        }
        .p1 {
            font-size: 30px;
            color: #333333;
            text-align: center;
            padding-bottom: 20px;
        }
        .p2 {
            font-size: 26px;
            color: #666666;
            text-align: center;
            line-height: 39px;
        }
    }
}
.weui-cell {
    --weui-FG-3: rgba(0, 0, 0, 0);
    border-bottom: 1px solid #eeeeee;
    &:last-child{
       border-bottom: none;
    }
    input {
        font-size: 16px;
    }
    .weui-label {
        font-size: 16px;
    }
    button {
        font-size: 12px;
    }
    .weui-btn_disabled {
        background: #ffffff;
        border: 1px solid #cccccc;
        color: #333333;
        font-weight: normal;
        
    }
}
.weui-loadmore__tips {
    background: #f5f5f5;
}
.weui-loadmore {
    margin: 20px auto 0;
}
::-webkit-input-placeholder {
    font-size: 30px;
    color: #cccccc;
}
</style>